export const otaking = {
    logo: {
        path: 'clients/otaking-logo-white.svg',
        alt: 'Otaking logo',
    },
};
